import '../../../../Assets/app.base';
import './EventTagUpcomingEvents.scss';

// Components
import '../../../../Components/InfiniteScrollView';
import '../../../../Components/NoResultsWarning';
import initEventListComponent from '../../../../Components/EventList';
import '../../../../Components/ParentingAssignmentDownload';

function init() {
  const infiniteScrollComponent = $('#event-scroll-container')
  infiniteScrollComponent.on('onContentLoad', function (event, element) {
    initEventListComponent(element)
  })
}

$(function () {
  init()
})
